import { dao } from '@platform/dao';
import type { IInboxWireItem, ISearchWireResult } from '@platform/dao';
import type { IMe, IPreferences, IRecentItem, IRecordLocation } from '@platform/core/types';
import { baseApi, run } from './baseApi';

export const meApi = baseApi.injectEndpoints({
  endpoints: (b) => ({
    me: b.query<IMe, void>({ queryFn: () => run(() => dao.me.me()), providesTags: ['Me'] }),
    inbox: b.query<IInboxWireItem[], { unreadOnly?: boolean }>({ queryFn: ({ unreadOnly }) => run(() => dao.me.inbox(unreadOnly)), providesTags: ['Inbox'] }),
    unreadCount: b.query<{ count: number }, void>({ queryFn: () => run(() => dao.me.unreadCount()), providesTags: ['Inbox'] }),
    markRead: b.mutation<void, string[] | undefined>({ queryFn: (ids) => run(() => dao.me.markRead(ids)), invalidatesTags: ['Inbox'] }),
    markUnread: b.mutation<void, string[]>({ queryFn: (ids) => run(() => dao.me.markUnread(ids)), invalidatesTags: ['Inbox'] }),
    recent: b.query<IRecentItem[], void>({ queryFn: () => run(() => dao.me.recent()), providesTags: ['Recent'] }),
    favourites: b.query<IRecentItem[], void>({ queryFn: () => run(() => dao.me.favourites()), providesTags: ['Favourites'] }),
    setFavourite: b.mutation<void, { recordId: string; on: boolean }>({
      queryFn: ({ recordId, on }) => run(() => dao.me.setFavourite(recordId, on)),
      invalidatesTags: ['Favourites'],
    }),
    updatePreferences: b.mutation<IPreferences, IPreferences>({ queryFn: (body) => run(() => dao.me.updatePreferences(body)), invalidatesTags: ['Me'] }),
    recordLocation: b.query<IRecordLocation, string>({ queryFn: (id) => run(() => dao.me.recordLocation(id)), keepUnusedDataFor: 0 }),
    search: b.query<ISearchWireResult, { q: string; workspaceId?: string; perGroup?: number; groupBy?: 'module' | 'recordType' }>({
      queryFn: ({ q, workspaceId, perGroup, groupBy }) => run(() => dao.search.search(q, workspaceId, perGroup, groupBy)),
    }),
  }),
});

export const {
  useMeQuery, useInboxQuery, useUnreadCountQuery, useMarkReadMutation, useMarkUnreadMutation, useRecentQuery, useFavouritesQuery,
  useSetFavouriteMutation, useUpdatePreferencesMutation, useSearchQuery, useRecordLocationQuery,
} = meApi;
